export default __webpack_public_path__ + "static/media/health-wellness.8fd4b5c3.png";